import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { ShiftTemplateEntity } from '../../domain/entities/ShiftTemplateEntity'
import moment from 'moment'
import type { ShiftTemplateAdminDto } from '@/backend/market'
export class ShiftTemplateModel extends ShiftTemplateEntity {
  startTime?: string
  duration?: string
  constructor(dataDto: ShiftTemplateAdminDto) {
    super()
    mapEntityProperties<ShiftTemplateEntity>(this, dataDto, {
      map: {
        startTimeDate: dataDto.startTime
          ? moment.utc(dataDto.startTime, 'HH:mm:ss').toDate()
          : undefined,
        durationDate: dataDto.duration ? moment(dataDto.duration, 'HH:mm:ss').toDate() : undefined,
        region: {
          id: dataDto.regionId,
          name: dataDto.regionName
        }
      }
    })
  }
}
